module.exports = __webpack_public_path__ + "static/media/home.edbafec9.svg";